var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.42236C0 4.14622 0.223858 3.92236 0.5 3.92236H6.29289L4.14645 1.77592C3.95118 1.58066 3.95118 1.26407 4.14645 1.06881C4.34171 0.873547 4.65829 0.873547 4.85355 1.06881L7.85355 4.06881C8.04882 4.26407 8.04882 4.58065 7.85355 4.77592L4.85355 7.77592C4.65829 7.97118 4.34171 7.97118 4.14645 7.77592C3.95118 7.58065 3.95118 7.26407 4.14645 7.06881L6.29289 4.92236H0.5C0.223858 4.92236 0 4.69851 0 4.42236Z",
    fill: "#FA712D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrange);
export default __webpack_public_path__ + "static/media/arrow-orange.806b3856b07a5883de571cab4c304c0b.svg";
export { ForwardRef as ReactComponent };